import axios from "axios";

const keyVaultSecretService = {
    async get(secretName) {
        const response = await axios.get(`api/secrets/get/${secretName}`);
        return response;
    },
    async set(keyVaultSecretInfo) {
        const response = await axios.post(`api/secrets/set/`, keyVaultSecretInfo);
        return response;
    },
    async delete(secretName) {
        const response = await axios.delete(`api/secrets/delete/${secretName}`);
        return response;
    }
}

export default keyVaultSecretService;